import React, { useState, useEffect } from "react";
import { View, TouchableOpacity } from "react-native";
import { Icon } from "@clearabee/ui-library-native";
import { trainStyles } from "./Train.styles";
import { calculateStepPosition, TrainContext } from "./Train.utils";
import { TrainItemVertical } from "./TranItemVertical";
import { TrainItemHorizontal } from "./TranItemHorizontal";
import type { TrainProps } from "./Train.types";

export const Train = ({
  steps,
  currentStep,
  defaultOpen = true,
  vertical = false,
  titleSize = "large",
}: TrainProps): React.ReactElement => {
  const [isOpen, setOpen] = useState(vertical ? defaultOpen : true);

  useEffect(() => {
    setOpen(vertical ? defaultOpen : true);
  }, [vertical, defaultOpen]);

  return (
    <>
      <View style={{ flexDirection: vertical ? "column" : "row" }}>
        {steps.map((props, step) =>
          !isOpen && currentStep !== step ? null : (
            <TrainContext.Provider
              key={`step-${step}`}
              value={{
                isOpen,
                currentStep,
                step,
                titleSize,
                numberOfSteps: steps.length,
                position: {
                  previous: calculateStepPosition(
                    step - 1,
                    currentStep,
                    steps.length,
                  ),
                  current: calculateStepPosition(
                    step,
                    currentStep,
                    steps.length,
                  ),
                  next: calculateStepPosition(
                    step + 1,
                    currentStep,
                    steps.length,
                  ),
                },
              }}
            >
              {vertical && <TrainItemVertical {...props} />}
              {!vertical && <TrainItemHorizontal {...props} />}
            </TrainContext.Provider>
          ),
        )}
      </View>
      {vertical && (
        <TouchableOpacity
          onPress={() => setOpen(!isOpen)}
          style={[
            trainStyles.trainOpenCloseButton,
            isOpen ? trainStyles.closeButton : trainStyles.openButton,
          ]}
        >
          <Icon.Chevron color="dark" size="medium" />
        </TouchableOpacity>
      )}
    </>
  );
};
